
export interface InviteUsersRequest {
  userIds: string[];
}
